var _path, _path2, _path3, _ellipse, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgErrorSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9281 5.99167C28.9012 6.01445 28.8745 6.0376 28.8483 6.06112L18.5246 15.3094C18.4421 15.3833 18.3636 15.4603 18.2893 15.5399H28.9281V5.99167ZM17.375 19.5399V83.8887C17.375 85.8352 19.1454 87.4212 21.3182 87.4212H78.4318C80.6046 87.4212 82.375 85.8352 82.375 83.8887V8.56372C82.375 6.61726 80.6046 5.03125 78.4318 5.03125H32.9281V15.8623C32.9281 17.8972 31.2783 19.5399 29.2587 19.5399H17.375Z",
    fill: "#E4EEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1541 82.1247C38.969 82.1247 29.875 73.0177 29.875 61.8167C29.875 50.6158 38.969 41.5088 50.1541 41.5088C61.3391 41.5088 70.4332 50.6158 70.4332 61.8167C70.4332 73.0177 61.3391 82.1247 50.1541 82.1247ZM50.1541 44.2165C40.4652 44.2165 32.5789 52.114 32.5789 61.8167C32.5789 71.5194 40.4652 79.4169 50.1541 79.4169C59.843 79.4169 67.7293 71.5194 67.7293 61.8167C67.7293 52.114 59.843 44.2165 50.1541 44.2165Z",
    fill: "#C6DAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9702 78.8306L65.7147 80.0879C64.4254 81.3791 64.4254 83.4725 65.7147 84.7636L78.0785 97.145C79.3679 98.4362 81.4583 98.4362 82.7476 97.145L84.0031 95.8877C85.2924 94.5966 85.2924 92.5032 84.0031 91.2121L71.6393 78.8306C70.3499 77.5395 68.2595 77.5395 66.9702 78.8306Z",
    fill: "#C6DAFF",
    stroke: "#C6DAFF",
    strokeWidth: 3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.1875,
    cy: 61.6345,
    rx: 17.8125,
    ry: 17.6101,
    fill: "#F0F8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7255 58.8392C37.6174 58.8392 37.5002 58.8212 37.392 58.7761C36.9324 58.5865 36.707 58.063 36.8873 57.6027C38.6989 53.0628 42.4032 49.6059 47.0539 48.1347C47.5316 47.9813 48.0363 48.243 48.1805 48.7214C48.3337 49.1997 48.0724 49.7052 47.5947 49.8496C43.4577 51.1583 40.168 54.2271 38.5547 58.2706C38.4105 58.6226 38.077 58.8392 37.7165 58.8392H37.7255Z",
    fill: "#C6DAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6347 64.5244C36.139 64.5244 35.7334 64.1182 35.7334 63.6218C35.7334 62.7734 35.7965 61.9159 35.9317 61.0765C36.0128 60.5801 36.4725 60.2552 36.9592 60.3274C37.4549 60.4086 37.7883 60.8689 37.7072 61.3563C37.5901 62.0965 37.536 62.8636 37.536 63.6218C37.536 64.1182 37.1304 64.5244 36.6347 64.5244Z",
    fill: "#C6DAFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.234 16.352H17.375L29.875 5.03125V5.3547V15.7051C29.875 16.2226 29.4476 16.352 29.234 16.352Z",
    fill: "#C6DAFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgErrorSearch);
export default __webpack_public_path__ + "static/media/img_error_search.78fb3f04ee16a0890f1e35aa5ba299d6.svg";
export { ForwardRef as ReactComponent };